/**
 * Request class, using the (polyfilled) fetch API
 * @class
 */
class Request {

    /**
     * Fetch data from an url
     * @param {string} url - The resource URL
     * @param {boolean} cacheBuster - a boolean
     * @return {Promise} - A Promise
     */
    fetch(url, cacheBuster) {

        return new Promise((resolve, reject) => {

            const request = new XMLHttpRequest();
            const glue = url.indexOf('?') === -1 ? '?' : '&';

            url = `${url}${glue}cache-bust=${(cacheBuster || Date.now())}`;

            request.open('GET', url);

            request.onload = function() {
                if (request.status === 200) {
                    resolve(request.response || request.responseText);
                } else {
                    reject(request.responseText);
                }
            };
            request.onerror = function() {
                reject(Error('There was a network error.'));
            };


            request.send();

        });
    }

    /**
     * Fetch JSON data from an URL
     * @param {string} url - The resource URL
     * @param {boolean} cacheBuster - a boolean
     * @returns {Promise} - A Promise, resolving with the parsed JSON data
     */
    fetchJSON(url, cacheBuster) {
        return this.fetch(url, cacheBuster).then(r => JSON.parse(r));
    }

    /**
     * Fetch plain text data from an URL
     * @param {string} url - The resource URL
     * @param {boolean} cacheBuster - a boolean
     * @returns {Promise} - A Promise, resolving with the plain text
     */
    fetchPlainText(url, cacheBuster) {
        return this.fetch(url, cacheBuster);
    }

}

export default new Request();
